import { useRoutes } from "react-router-dom";

import { PRIVATE_ROUTES, PUBLIC_ROUTES, COMPANY_ROUTES } from "./pages/appRoutes";

function Router() {

  const info = JSON.parse(localStorage.getItem("admin-info"));

  const routes = useRoutes(
    localStorage.getItem("access-token")
      ? (info?.role === 1 || info?.role === 3)
        ? PRIVATE_ROUTES
        : COMPANY_ROUTES
      : PUBLIC_ROUTES
  );
  return routes;
}

export default Router;
